"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _HBBanner = require("./HBBanner.styles");
var _excluded = ["text"];
var BannerActions = function BannerActions(_ref) {
  var secondaryAction = _ref.secondaryAction,
    testId = _ref.testId,
    primaryAction = _ref.primaryAction,
    actionsTheme = _ref.actionsTheme,
    primaryActionTheme = _ref.primaryActionTheme,
    actionTextTransform = _ref.actionTextTransform,
    actionsSize = _ref.actionsSize,
    align = _ref.align,
    className = _ref.className;
  if (!primaryAction) {
    return null;
  }
  var commonActionProps = {
    size: actionsSize,
    isLink: actionsTheme === 'button-link'
  };
  return /*#__PURE__*/_react["default"].createElement(_HBBanner.Actions, {
    align: align,
    className: className
  }, secondaryAction && /*#__PURE__*/_react["default"].createElement(BannerAction, (0, _extends2["default"])({
    action: secondaryAction,
    buttonTheme: "secondary-invisible-secondary",
    testId: testId ? "".concat(testId, "-secondary-button") : undefined
  }, commonActionProps)), /*#__PURE__*/_react["default"].createElement(BannerAction, (0, _extends2["default"])({
    action: primaryAction,
    buttonTheme: primaryActionTheme,
    textTransform: actionTextTransform,
    testId: testId ? "".concat(testId, "-primary-button") : undefined
  }, commonActionProps)));
};
var _default = exports["default"] = BannerActions;
var BannerAction = function BannerAction(_ref2) {
  var _ref2$action = _ref2.action,
    text = _ref2$action.text,
    action = (0, _objectWithoutProperties2["default"])(_ref2$action, _excluded),
    buttonTheme = _ref2.buttonTheme,
    testId = _ref2.testId,
    _ref2$textTransform = _ref2.textTransform,
    textTransform = _ref2$textTransform === void 0 ? 'uppercase' : _ref2$textTransform,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'xs' : _ref2$size,
    _ref2$isLink = _ref2.isLink,
    isLink = _ref2$isLink === void 0 ? false : _ref2$isLink;
  return /*#__PURE__*/_react["default"].createElement(_HBBanner.StyledHBButton, (0, _extends2["default"])({
    isLink: isLink,
    size: size,
    buttonTheme: buttonTheme,
    textTransform: textTransform,
    testId: testId
  }, action), text);
};
//# sourceMappingURL=BannerActions.js.map